/**
 * LocalOrderItemSale entity - maps to local_order_item_sales table.
 */

import type { EntitySchema } from '../types';

export interface LocalOrderItemSale {
  id: string;
  local_order_item_id: string;
  sale_type_id: string | null;
  name: string;
  percent_value: number;
  value: number;
}

export const LocalOrderItemSaleSchema: EntitySchema<LocalOrderItemSale> = {
  tableName: 'local_order_item_sales',
  columns: [
    { name: 'id', type: 'TEXT', primary: true },
    {
      name: 'local_order_item_id',
      type: 'TEXT',
      nullable: false,
      references: {
        table: 'local_order_items',
        column: 'id',
        onDelete: 'CASCADE',
      },
    },
    { name: 'sale_type_id', type: 'TEXT', nullable: true },
    { name: 'name', type: 'TEXT', nullable: false },
    { name: 'percent_value', type: 'REAL', nullable: false, default: 0 },
    { name: 'value', type: 'REAL', nullable: false, default: 0 },
  ],
  indexes: [
    { name: 'idx_local_order_item_sales_item_id', columns: ['local_order_item_id'] },
  ],
};
